import { useCallback, useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, Button, Paper } from '@mui/material';
import { Settings } from '../../../interfaces/Settings/Settings';
import { getSettingsByType, upsertSettings } from '../../../api/Settings';
import { SettingsType } from '../../../interfaces/Settings/SettingsType';
import { GenericSettingsValue } from '../../../interfaces/Settings/GenericSettingsValue';
import { getSettingsValue, getUpdatedSettings } from '../../../utils/Settings';
import { Waiting } from '../../../components/Waiting/Waiting';
import { SettingsRow } from '../../../components/Settings/SettingsRow';
import { SettingsValueType } from '../../../interfaces/Settings/SettingsValueType';
import { sharedStyles } from '../../../utils/Style';

export const PreferredPaymentProviderSettings = () => {
  const [settings, setSettings] = useState<Settings[]>([]);
  const [loading, setLoading] = useState(true);

  const refreshSettings = () => {
    setLoading(true);
    getSettingsByType(SettingsType.PAYMENT_PROVIDER)
      .then((s) => setSettings(s))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshSettings();
  }, []);

  const handleChange = useCallback(
    (key: string, newValue: GenericSettingsValue) =>
      setSettings(
        getUpdatedSettings(
          SettingsType.PAYMENT_PROVIDER,
          key,
          settings,
          newValue,
        ),
      ),
    [settings],
  );

  const handleSave = () => {
    setLoading(true);
    upsertSettings(settings)
      .then(() => {
        toast.success('Ayarlar başarıyla kaydedildi');
        refreshSettings();
      })
      .catch((err) => {
        toast.error(err.message);
        setLoading(false);
      });
  };

  return (
    <Paper
      sx={{
        p: 1.5,
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        height: '85%',
      }}
    >
      <Waiting open={loading} />

      <SettingsRow
        name='Aktif Ödeme Yöntemi'
        valueType={SettingsValueType.SELECT}
        value={getSettingsValue(settings, 'active_payment_method')}
        onChange={(newValue) => handleChange('active_payment_method', newValue)}
        options={[
          { value: 'ziraat', label: 'Ziraat Bankası' },
          { value: 'param', label: 'Param Pos' },
          {
            value: 'halk',
            label: 'Halkbank',
          },
        ]}
      />

      <Box display='flex' justifyContent='flex-end'>
        <Button
          variant='contained'
          onClick={handleSave}
          sx={{ ...sharedStyles.buttonText, mt: 1.5 }}
        >
          Kaydet
        </Button>
      </Box>
    </Paper>
  );
};
